import { patch } from "@/shared/axios";
import useOrders from "@/shared/hooks/useOrders";
import { errorToast } from "@/shared/utils/helpers";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

interface Body {
  orderId: number;
  status: string;
}

const useUpdateOrderMutation = (
  customOptions?: Omit<
    UseMutationOptions<any, unknown, Body, unknown>,
    "mutationFn"
  >
) => {
  const options = customOptions ?? {
    onSuccess: () => {
      toast.success(t("success.update"));
    },
    onError: () => {
      errorToast();
    },
  };
  const { t } = useTranslation();
  const { data } = useOrders(true);
  const mutation = useMutation({
    ...options,
    mutationFn: ({ orderId, status }: Body) => {
      const branch = data
        .flat()
        .find((order) => order.order_information.item_id === orderId)
        ?.order_information.branch_id;
      return patch(
        `internal/secure/pos/v1/orders/information/status/changed/by/courier/${branch}/${orderId}/${status}`,
        {}
      );
    },
  });
  return mutation;
};

export default useUpdateOrderMutation;
